export default "__VITE_ASSET__D2377h8c__"